import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import {Autocomplete, TextField} from '@mui/material';
import { HeadingWrap, CommonButton, Span,  BackButtonSpan } from '../../../../Styles/CommonStyles';
import { Span as OriginalSpan } from '../../../../Styles/CommonStyles';
import { useAddUserAssetsMutation, useAddUserIndiAssetsMutation, useGetUsersQuery, useModifyArrayUserMutation } from '../../../../features/users/usersApiSlice';
import nameStringFn from '../../../../data/nameStringFn';
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import Popup from 'reactjs-popup';
import { useGetAssetsFinalQuery, useUpdateAddAssetFinalMutation, useUpdateMultipleDocsMutation, useUpdateOldIssueDateMutation } from '../../../../features/addassets/addassetfinalApiSlice';
import { useGetAppIndividualAssetsQuery } from '../../../../features/appindividualassets/appindassetsApiSlice';
import JoditEditor from 'jodit-react';
import moment from 'moment';
import ReactTooltip from "react-tooltip";
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import SelectAssetsModal from './SelectAssetsModal';
import useAuth from '../../../../features/hooks/useAuth';
import { useSelector } from 'react-redux';
import { useUploadFileMutation } from '../../../../features/fileupload/fileuploadApiSlice';
import { useNavigate } from 'react-router-dom';
import { use } from 'react';


const StartAlignedSpan = styled(OriginalSpan)`
  align-items: flex-start;
`;
const tableStyle = {
  width: '53%',
  borderCollapse: 'collapse',
  marginTop: '20px',
};
const thTdStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  textAlign: 'left',
  fontSize: '20px'
};

const thStyle = {
  backgroundColor: '#aae2e4',
  fontSize: '23px'
};
const evenRowStyle = {
  backgroundColor: '#f9f9f9',
};
const PopupButton = styled(CommonButton)`
  background-color: #2E5894;
`
const Issuebutton = styled(CommonButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10vw;
  height: 50px;
  background-color: teal;
  margin-right: 30px;
  cursor: pointer;
  border-radius: 10px; 
`
const TextInputWrap = styled.div`
  margin-bottom:10px;
`
const Container = styled.div`
    width: 100%;
`
const Wrapper = styled.div`
    width: 100%;
`
const UploadPdfWrapper = styled.div`
  display: flex;
  align-items:center;
`
const InputFile = styled.input`
  width: 180px;
  display: none;
`
const SelectFileReset = styled.button`
  background-color: transparent;
  color: #999;
  border: none;
  font-size: 35px;
  cursor: pointer;
  padding: 0;
  margin-left:2px;
`
const ViewButton = styled.button`
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-right:5px;
  margin-left: 5px;
  cursor: pointer;  
`
const CustomFileUploadButton = styled.label`
  /* Add your desired button styles */
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-right:5px;
  cursor: pointer;
`
const AllWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: space-around;
    flex-grow: 1;
    row-gap: 50px;
    margin-bottom: 20px;
`
const SubHeadingField = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-left:15px;
    margin-top: 10px;
    margin-bottom: 5px;
    font-weight: bold;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-size: 24px;
    font-weight: 900;
    color: #5C5891;  
`
const InnerContainer = styled.div`
    display:flex;
    border-left: 3px solid #955EFF;
    align-items: center;
    position: absolute;
    top: 20%;
    bottom: 20%;
    padding: 25px;
`
const OptionContainer = styled.div`
    width:350px;
    display: flex;
    height:150px;
    background-color:#fff;
    /* align-items: center;
    justify-content: center; */
    color: #58548E;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-size: 1.2857142857142856rem;
    line-height: 1.334;
    letter-spacing: 0em;
    margin-left: 24px;
    font-weight: 700;
    cursor: pointer;
    position: relative;
    transition: box-shadow 0.3s;
    &:hover{
        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    }
`
const OptWrap = styled.div``
const CurrSelAssetsCont = styled.div``

const IndiWrap = styled.div`
  margin-bottom: 20px;
`
const EmailSelectWrap = styled.div`
  margin-right: 20px;
`
const SingleUserWrap = styled.div`
display: flex;
`
const SingleoffCont = styled.div`
`
const SingleSelectCont = styled.div`
`
const AssetTagselCon = styled.div`
  display: flex;
`

const MultiUserCont = styled.div``
const MultiUserWrap = styled.div``
const UserSelectWrap = styled.div``
const OfficeSelectWrap = styled.div`
  margin-bottom: 20px;
`

const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
const getCurrentDateISO = () => {
  const today = new Date();
  return today.toISOString();
}

const AssetDistribute = () => {
  const [byEmailClicked, setByEmailClicked] = useState(false);
  const [byOfficeClicked, setByOfficeClicked] = useState(false);
  const [indiAssets, setIndiAssets] = useState('No');
  const [emailId, setEmailId] = useState("");
  const [selectedUser, setSelectedUser] = useState({});
  const [offsingle, setOffsigle] = useState();
  const [selectedOff1, setSelectedOff1] = useState();
  const [selectedUserbyOff, setSelectedUserbyOff] = useState();
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const editor = useRef(null);
  const [content, setContent] = useState('');
  const [dateArray, setDateArray] = useState([]);
  const [assetdetailmodalopen, setAssetDetailmodalopen] = useState(false);
  const [selectedfile, setSelectedFile] = useState(null);
  const [assetsUpdateBody, setAssetsUpdateBody] = useState();
  const [jsonData, setJsonData] = useState({collection:"transactions", data:{}, type:"addnew", oldPath:""});
  const navigate = useNavigate();

  const inputPdfFile = useRef(null);

  const { id, email, designation,  roles } = useAuth();
  let user_current_office = (useSelector((state) => state.office.off));

console.log(roles)
  const { users } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      users: data?.entities
    }),
  })
  const { offices } = useGetofficesQuery('offices', {
    selectFromResult: ({ data }) => ({
      offices: data?.entities
    }),
  })

  const { assets } = useGetAssetsFinalQuery('assets', {
    selectFromResult: ({ data }) => ({
        assets: data?.entities
    }),
  })  
  const { individualassets } = useGetAppIndividualAssetsQuery('individualassets', {
    selectFromResult: ({ data }) => ({
      individualassets: data?.entities
    }),
  })

  
  // update old issue date in old assets
  const [updatepldissuedate, { isLoading: updateolddateloading }] = useUpdateOldIssueDateMutation();
  // modify user document by adding/removing assets in the array field
  const [modifyArrayUser] = useModifyArrayUserMutation();
  // update multiple documents in assets collection
  const [updateMultipleAssetDocs] = useUpdateMultipleDocsMutation();
  
  

  const [uploadFile, {isLoading:uploadfileloading}] = useUploadFileMutation();
  const folderName = "directrequest"

  const backClickedHandler = () => {
    setByEmailClicked(false);
    setByOfficeClicked(false);
    setIndiAssets("No");
    setEmailId();
    setOffsigle();
    setSelectedUserbyOff();
    setSelectedUser();
    setSelectedOff1();
    setSelectedOptions([]);
  }
   // handle file upload
   const handlePdfFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === 'application/pdf') {
        setSelectedFile(file)       
      } else {
        alert('Please select only PDF file.');
        event.target.value = null;
      }
    }
  }
  const handlePdfUploadButtonClick = () => {
    inputPdfFile?.current?.click();
  };
  const deleteSelectFile = () => {
    if (inputPdfFile.current) {
      inputPdfFile.current.value = null;
      inputPdfFile.current.type = "text";
      inputPdfFile.current.type = "file";
      setSelectedFile(null);
    }
  }
  const handleviewFile = () =>{
    window.open(URL.createObjectURL(selectedfile), '_blank');
  }  
  const handleEmailSelect = (event, newValue) => {
      setEmailId(newValue);
      if(newValue?.length){
          const tempUser = Object.values(users).find(x => x.email === newValue);
          setSelectedUser(tempUser);
      } else {
          setSelectedUser({});
          setSelectedOptions([])
      }
      setOffsigle()
  }

  const handleSelectOffice = (event, newValue) => {
    setSelectedOff1(newValue);
    const tempFilteredUsers = Object.values(users).filter(x => (x.office.mainCharge === newValue || x.office.additionalCharge.includes(newValue)));
    setFilteredUsers(tempFilteredUsers);
  }
  const handleselectedUserbyOff = (event, newValue) => {
    setSelectedUserbyOff(newValue);
    setEmailId(newValue?.value?.email);
  }
  const handleSelectAssetsModalClose = () => {
    setAssetDetailmodalopen(false);
  }
  const handledateInput = (event, id) => {
    const newDate = event?.$d.toISOString();
    setDateArray(prevDateArray => {
        const existingIndex = prevDateArray.findIndex(item => item.id === id);
        if (existingIndex >= 0) {
            // Update existing entry
            const updatedArray = [...prevDateArray];
            updatedArray[existingIndex] = { id, old_issue_date: newDate };
            return updatedArray;
        } else {
            // Add new entry
            return [...prevDateArray, { id, old_issue_date: newDate }];
        }
    });
};
const getValue = (id) => {
    const item = dateArray.find(entry => entry.id === id);
    return item ? dayjs(item.old_issue_date) : null;
};
const handlePopup = () => {
  setAssetDetailmodalopen(true);
}
const IssueClickHandlerSin = async () => {
  if(indiAssets === "Yes"){
    const indiConfirm = window.confirm('You have selected "Yes" for assets to be issued by name. Please confirm');
    if (!indiConfirm) return alert("Cancelled");
  }
  if(byEmailClicked){
    if(!emailId) return alert('Please select emailId');
    if(!offsingle) return alert('Please Select Office');
  }
  if(byOfficeClicked){
    if(!selectedOff1) return alert('Please Select Office');
    if(!selectedUserbyOff) return alert('Please Select User')
  }
  if(!selectedOptions.length) return alert("Please select at least one asset");
  if(selectedfile){
    const confirmation = window.confirm(`Please verify the uploaded file first as if it get submitted once can not be edited. If you like to continue with current file Press 'Ok' or Press 'cancel' to reselect the file.`);
    if(!confirmation) return alert("Cancelled")
  }
  if(selectedOptions?.map(x => x.id).some(elm => (assets[elm].olderAssetsLot === 'Yes' && assets[elm].old_issue_date === null))){
    const filteredLength = selectedOptions?.map(x => x.id).filter(elm => (assets[elm].olderAssetsLot === 'Yes' && assets[elm].old_issue_date === null)).length;
    if(filteredLength !== dateArray.length) return alert("Please fill all Older Issue Dates");
  }  

  //others APIs
  try {

    //create request (If file is selected, it will be appended else only json data will be added)
    const formData = new FormData();
    if(selectedfile) formData.append('file', selectedfile);
    formData.append('jsonData', JSON.stringify(jsonData));
    const res1 = await uploadFile({ formData, folder: folderName }).unwrap();

    // update assets by inserting user Id in all issued assets.
    const res2 = await updateMultipleAssetDocs(assetsUpdateBody);

    // update old assets issue date if any
    const res3 = await updatepldissuedate({ array: dateArray });

    navigate('/management/assets/AssetMan');
    return alert('Assets allocated to the user');
  } catch (err) {
    return alert(`Error:${err}`)
  }
}
console.log(assetsUpdateBody)


useEffect(()=>{
  if(selectedOptions.length){
    const finalSelectedUser = selectedUserbyOff? selectedUserbyOff.value:selectedUser;
    const userid = finalSelectedUser._id;
    const userOffice = offsingle? offsingle.value:selectedOff1;

    //TransactionData
    const transacData = {
      transac_id:`TR${indiAssets === "Yes"? "DDI":"DDS"}-${Date.now().toString(36)}`,
      req_id:"",
      asset_id: selectedOptions?.map(x => x.id),
      transac_type:"directdistribute",
      indi_asset: indiAssets === "Yes"? true : false,
      from_userid: email,
      from_office: user_current_office,
      from_desig: designation?.[user_current_office],
      from_store: user_current_office,
      to_userid: finalSelectedUser?.email,
      to_office: userOffice,
      to_desig: finalSelectedUser?.designation?.[userOffice],
      to_store:user_current_office,
      pdfPath:"",
      time_stamp: getCurrentDateISO()
    }
 
    setJsonData(prevValue => ({
      ...prevValue, data: transacData 
    }));
  

    // selecetd user id to be inserted in all assets to be issued
    setAssetsUpdateBody(
      {
        assetIdArray: selectedOptions.map(x => x.id) || [],
        updates: {
          cur_loc: "user",
          last_trans_date: new Date().toISOString(),
          alloc_user: userid,
          alloc_ofc: userOffice,
          indi_issue: indiAssets === "Yes"? true:false,
          cur_user_name: `${finalSelectedUser?.email} (${nameStringFn(finalSelectedUser)})`
        }
      }
    )        
  }       
},[users, emailId, selectedOptions]);

  return (
    <Container>
      {(byEmailClicked || byOfficeClicked) && <BackArrowContainer onClick={backClickedHandler}><ArrowLeftIcon /><BackButtonSpan >Back </BackButtonSpan></BackArrowContainer>}
        <Wrapper>
          <AllWrapper>
            {!byEmailClicked && !byOfficeClicked && <OptionContainer onClick={(e) => setByEmailClicked(true)}><InnerContainer>Select User By Email</InnerContainer></OptionContainer>}
            {!byEmailClicked && !byOfficeClicked && <OptionContainer onClick={(e) => setByOfficeClicked(true)}><InnerContainer>Select User By Office </InnerContainer></OptionContainer>}
          </AllWrapper>
          <OptWrap>
            {(byEmailClicked || byOfficeClicked) && <IndiWrap>
              <Autocomplete
                id="combo-box-demo"
                options={['Yes', 'No']}
                sx={{ width: 400 }}
                value={indiAssets}
                onChange={(event, newValue) => {
                    setIndiAssets(newValue);
                    setSelectedOptions([]);
                }}
                renderInput={(params) => <TextField {...params} label="Is the asset to be issued to individual by Name?" />}
              />
            </IndiWrap>}
            {!byOfficeClicked && byEmailClicked && <><SingleUserWrap>
              <EmailSelectWrap>
                <Autocomplete
                  id="combo-box-demo"
                  options={users? Object.values(users)?.map(elm => elm.email):[]}
                  sx={{ width: 400 }}
                  value={emailId}
                  onChange={(event, newValue) => handleEmailSelect(event, newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderInput={(params) => <TextField {...params} label="Enter user Email Id" />}
                />
              </EmailSelectWrap>
              {emailId && <SingleoffCont>
                <SingleSelectCont>
                  <Autocomplete
                    id="combo-box-demo"
                    options={[{label:`${selectedUser?.office?.mainCharge} (Main Charge)`,value:selectedUser?.office?.mainCharge}].concat(selectedUser.office.additionalCharge.map(x => { return {label:x, value:x}}))}
                    sx={{ width: 400 }}
                    value={offsingle?.label?.length? offsingle.label: null}
                    onChange={(event, newValue) => {
                        setOffsigle(newValue);
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderInput={(params) => <TextField {...params} label="Select Office" />}
                  />
                </SingleSelectCont>
              </SingleoffCont>}
            </SingleUserWrap>
            {offsingle?.label?.length && <StartAlignedSpan>{`Name: ${nameStringFn(selectedUser)}, Designation: ${selectedUser?.designation[offsingle?.value]}`}</StartAlignedSpan>}
            </>}
          </OptWrap>
          <OptWrap>
            <MultiUserCont>
              {byOfficeClicked && !byEmailClicked && <MultiUserWrap>
                <OfficeSelectWrap>
                  <Autocomplete
                    id="combo-box-demo"
                    options={Object.values(offices)?.map(elm => elm.name)}
                    sx={{ width: 400 }}
                    value={selectedOff1 || null}
                    onChange={(event, newValue) => handleSelectOffice(event, newValue)}
                    renderInput={(params) => <TextField {...params} label="Select Office" />}
                  />
                </OfficeSelectWrap>
                <UserSelectWrap>
                  <Autocomplete
                    id="combo-box-demo"
                    options={filteredUsers?.length? filteredUsers.map(x => {return {label:`${x?.email} (${nameStringFn(x)})- ${x?.designation[selectedOff1]}`, value:x} }):[]}
                    sx={{ width: 400 }}
                    value={selectedUserbyOff || null}
                    onChange={(event, newValue) => handleselectedUserbyOff(event, newValue)}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderInput={(params) => <TextField {...params} label="Select User" />}
                  />
                  </UserSelectWrap>
                    {selectedUserbyOff && <StartAlignedSpan>{`Name: ${nameStringFn(selectedUserbyOff?.value)}, Designation: ${selectedUserbyOff?.value?.designation[selectedOff1]}`}</StartAlignedSpan>}
                </MultiUserWrap>}
            </MultiUserCont>
          </OptWrap>
          {((byOfficeClicked || byEmailClicked) && (((emailId && offsingle)) || (selectedOff1 && selectedUserbyOff ))) && <div>
            <AssetTagselCon>
              <SubHeadingField>To Issue Assets:</SubHeadingField>
              <PopupButton type='button' onClick={handlePopup} >Go to Store Assets</PopupButton>             
            </AssetTagselCon>
            <TextInputWrap>
                <HeadingWrap>
                    <Span>Details/Justifications</Span>
                </HeadingWrap>
                <JoditEditor
                    ref={editor}
                    value={content}
                    onBlur={newContent => setContent(newContent)}
                    onChange={newContent => { }}
                    config={{ height: '20vh' }}
                />            
            </TextInputWrap>
            <UploadPdfWrapper>
              <InputFile type="file" onChange={handlePdfFileChange} ref={inputPdfFile}/>
              <CustomFileUploadButton htmlFor="file-upload" onClick={handlePdfUploadButtonClick}>
              Upload reference document as a single PDF only
              </CustomFileUploadButton>
              {selectedfile  && <><span>{selectedfile.name}</span><SelectFileReset type='button' onClick={() => deleteSelectFile()} >&times;</SelectFileReset><ViewButton type='button' onClick={handleviewFile}>View File</ViewButton></>}
            </UploadPdfWrapper>
        </div>
        }
        {selectedOptions.length > 0 && (byOfficeClicked || byEmailClicked) && <CurrSelAssetsCont>
          <Span> Selected Assets to be issued:</Span>
          <table style={tableStyle}>
            <thead>
                <tr>
                    <th style={{ ...thTdStyle, ...thStyle }}>Assets</th>
                    <th style={{ ...thTdStyle, ...thStyle }}>OEM Tags</th>
                    <th style={{ ...thTdStyle, ...thStyle }}>OEM/Brand</th>
                    <th style={{ ...thTdStyle, ...thStyle }}>Purchase Date</th>
                    <th style={{ ...thTdStyle, ...thStyle }}>Warranty Date</th>
                    <th style={{ ...thTdStyle, ...thStyle }}>Specifications</th>
                    {(selectedOptions.map(x => x.id).filter(elm => (assets[elm].olderAssetsLot === 'Yes' && assets[elm].old_issue_date === null)).length) && <th style={{ ...thTdStyle, ...thStyle }}>Older Issue date</th>}
                </tr>
            </thead>
            <tbody>
              {selectedOptions?.map(x => x.id)?.map((row, index) => (
                <tr key={index} style={(index + 1) % 2 === 0 ? evenRowStyle : null}>
                  <td style={thTdStyle}>{assets[row].name}</td>
                  <td style={thTdStyle}>{assets[row].oem_tag}</td>
                  <td style={thTdStyle}>{assets[row].oem}</td>
                  <td style={thTdStyle}>{moment(assets[row].purchase_date).format('DD/MM/YYYY')}</td>
                  <td style={thTdStyle}>{moment(assets[row].warrantyexp_date).format('DD/MM/YYYY')}</td>
                  <td style={thTdStyle}><div className="App">
                    <div data-tip data-for={assets[row]._id}>
                      Hover here to view Specifications
                    </div>
                    <ReactTooltip id={assets[row]._id} place="top" effect="solid">
                      <div>
                        {Object.entries(assets[row]?.specification).map(([key, val]) => <h4 key={key}>{key}: {val}</h4>)}
                      </div>
                    </ReactTooltip>
                  </div></td>
                  {(assets[row].olderAssetsLot === 'Yes' && assets[row].old_issue_date === null) && <td style={thTdStyle}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DatePicker', 'DatePicker']}>
                        <DateTimePicker
                            label="Please enter the old asset issue date"
                            value={getValue(assets[row]?._id)}
                            name={assets[row]?._id}
                            format="DD/MM/YYYY hh:mm a"
                            required={true}
                            onChange={(event) => handledateInput(event, assets[row]?._id)}        
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </td>}
                </tr>
              ))}
            </tbody>
          </table>
        </CurrSelAssetsCont>}
        </Wrapper>
        {(byOfficeClicked || byEmailClicked) && <Issuebutton disabled={ updateolddateloading || uploadfileloading} onClick={IssueClickHandlerSin}>{( updateolddateloading || uploadfileloading)? "Loading": "Create Issue"}</Issuebutton>}
    {assets && <SelectAssetsModal
      selectassetmodalopen={assetdetailmodalopen}
      handleSelectAssetsModalClose={handleSelectAssetsModalClose}
      setSelectedOptions={setSelectedOptions}
      selectedOptions={selectedOptions}
      filterProps={{ perm_cur_loc: ["store"], perm_cur_store: [user_current_office], perm_name: indiAssets === "Yes"? Object.values(individualassets).map( x => x.asset):[], perm_notname:indiAssets === "No"? Object.values(individualassets).map( x => x.asset):[],  in_transit: "false" }}
      />}
    </Container>
  )
}
export default AssetDistribute